// import resume from '../assets/pdf/resume.pdf'
import Profile from '../assets/png/Profile.png'

export const headerData = {
    name: 'Stéphane Devaux',
    title: "Fullstack and Cloud Developer",
    desciption:"",
    image: Profile,
}
// resumePdf: resume